import { type CustomerApi } from '@/features/iam/api/iam-api'
import { Id } from '@/infra/id'

export interface CreateCustomerParams {
  workspaceId: Id
  email: string
  givenName: string
  familyName: string
  phoneNumber?: string
  /**
   * Assigns this advisor to the customer as a client. If the customer is
   * already a member of the workspace, they are only assigned.
   */
  advisorUserPublicId?: Id
}

export interface CreatedCustomer {
  userPublicId: Id
}

export class CustomerStore {
  constructor(private readonly _api: CustomerApi) {}

  async createCustomer(params: CreateCustomerParams): Promise<CreatedCustomer> {
    const resource = await this._api.create({
      workspace_id: Id.assert(params.workspaceId),
      email: params.email,
      given_name: params.givenName,
      family_name: params.familyName,
      phone_number: params.phoneNumber,
      advisor_user_public_id: params.advisorUserPublicId,
    })
    return { userPublicId: resource.id }
  }
}
